import { InfoResourcesPackage } from "../../resources/InfoResourcesPackage";
import { BasePage } from "./BasePage";
import { Spine } from "pixi-spine";
import { TextStyle } from "@pixi/text";
import { FitText } from "../../../common/components/FitText";
import { Localization } from "../../../common/Localization";
import { getDefaultFontFamily } from "../../../common/TextUtils";

export class HowToPlayPage extends BasePage {
    private howToPlayText: FitText;
    private tutorialAnimation: Spine;
    private tutorialText: FitText;

    public constructor(
        private readonly infoResources: InfoResourcesPackage,
        private readonly localization: Localization
    ) {
        super();
        this.build();
        this.layout();
        this.once("added", this.layout, this);
    }

    public override hide(): void {
        this.tutorialAnimation.state.clearTrack(0);
        super.hide();
    }

    public override show(): void {
        super.show();
        this.tutorialAnimation.state.setAnimation(0, "Tutorial", true);
    }

    private build(): void {
        this.howToPlayText = new FitText(this.localization.getText("how_to_play"), this.getInfoTextStyle(36), 420, 100);
        this.addChild(this.howToPlayText);
        this.tutorialAnimation = new Spine((this.infoResources.assets_info_tutorial_json as any).spineData);
        this.tutorialAnimation.state.setAnimation(0, "Tutorial", true);
        this.addChild(this.tutorialAnimation);
        this.tutorialText = new FitText(this.localization.getText("info_text"), this.getInfoTextStyle(36), 530, 150);
        this.addChild(this.tutorialText);
    }

    private layout(): void {
        this.howToPlayText.position.set((this.width - this.howToPlayText.width) * 0.5, 0);
        this.tutorialAnimation.position.set(this.width * 0.5, 320);
        this.tutorialText.position.set((this.width - this.tutorialText.width) * 0.5, 600);
    }

    private getInfoTextStyle(size: number): TextStyle {
        return new TextStyle({
            fontFamily: getDefaultFontFamily(),
            fontSize: size,
            fill: "#4A5F66",
            align: "center"
        });
    }
}